import { render } from "./StaffDetail.vue?vue&type=template&id=acaa6844"
import script from "./StaffDetail.vue?vue&type=script&lang=js"
export * from "./StaffDetail.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/html/levante_web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__